// extracted by mini-css-extract-plugin
export default {"wrapper":"EditModeToggle_wrapper__tve9T"};